module.exports = __webpack_public_path__ + "static/media/47-meters-down.172c5a94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/47-meters-down.jpg
// module id = 289
// module chunks = 0